import { postPriceSchemeRequest, ICreatePriceSchemeRequestBody } from 'src/utils/priceSchemes/postPriceSchemeRequest';
import { API_URL } from '../constants';

export const duplicatePriceScheme = async (priceSchemeId: string, requestBody: ICreatePriceSchemeRequestBody) => {
  return postPriceSchemeRequest(`${API_URL}/pricing/schemes/${priceSchemeId}/duplicate`, JSON.stringify(requestBody));
};
